import React, { useState, useEffect } from "react";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import moment from "moment";
import Select from "react-select";
import { DateRangePicker, DatePicker } from "rsuite";
import Pagination from "@material-ui/lab/Pagination";
import dateFormat from "dateformat";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../pages/pagination.css";

const Pan = () => {
  const [isLoading, setIsLoading] = useState(false);
  // const [selectedDateRange, setSelectedDateRange] = useState();
  const [productData, setProductData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dashboardListData, setDashboardListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);


  const pageSize = 10;

  useEffect(() => {
    if (selectedProduct) {
      getLogsDetails();
    }
    CommonService.productList()
      .then((response) => {
        const products = response.data.data || [];
        const productOptions = products.map((product) => ({
          value: product.id,
          label: product.name,
        }));
        setProductData(productOptions);
        if (productOptions.length > 0) {
          setSelectedProduct(productOptions[0]);
        }
      })
      .catch((error) => {
        console.log("Error fetching product list:", error);
      });
  }, []);

  const getLogsDetails = (pageNumber = 1) => {
    const clientId = localStorage.getItem("id");
    const fromDate = selectedDateRange?.[0] ? moment(selectedDateRange[0]) : moment();
    const toDate = selectedDateRange?.[1] ? moment(selectedDateRange[1]) : moment();
    const formattedDateRange = `${fromDate.format("DD/MM/YYYY")}-${toDate.format("DD/MM/YYYY")}`;

    const payload = {
      clientId,
      dateRange: formattedDateRange,
      productId: selectedProduct?.value || null,
      orderBy: "id desc",
      page: pageNumber - 1,
      pageSize,
    };

    setIsLoading(true);
    CommonService.getLogs(payload)
      .then((response) => {
        const data = response.data.data;
        setDashboardListData(data.data || []);
        setTotalEntries(data.totalRecords || 0);
        setTotalPages(Math.ceil((data.totalRecords || 0) / pageSize));
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Error fetching logs:", error);
        setIsLoading(false);
      });
  };

  const exportExcel = () => {
    const clientId = localStorage.getItem("id");
    const fromDate = selectedDateRange?.[0] ? moment(selectedDateRange[0]) : moment();
    const toDate = selectedDateRange?.[1] ? moment(selectedDateRange[1]) : moment();
    const formattedDateRange = `${fromDate.format("DD/MM/YYYY")}-${toDate.format("DD/MM/YYYY")}`;

    const payload = {
      clientId,
      dateRange: formattedDateRange,
      productId: selectedProduct?.value || null,
      orderBy: "id desc",
    };

    setIsLoading(true);
    CommonService.getLogsExport(payload)
      .then((response) => {
        const exportData = response.data.data || [];
        if (exportData.length === 0) {
          alert("No data to export.");
          setIsLoading(false);
          return;
        }

        const worksheet = XLSX.utils.json_to_sheet(
          exportData.map((item, index) => ({
            "Sr. No.": index + 1,
            "URN": item.urn,
            "RC Number": item.rc_number,
            "Request Time": dateFormat(item.created_at, "dd-mm-yyyy HH:MM:ss"),
            "Status Code": item.status_code,
          }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Logs Report");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(fileData, `Logs_Report_${formattedDateRange}.xlsx`);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Error exporting logs:", error);
        setIsLoading(false);
      });
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    getLogsDetails(value);
  };

  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(startIndex + pageSize - 1, totalEntries);

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navigation />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card h-100">
                      <div className="card-body">
                        <div className="row">
                          <h5 className="card-header">Logs Report</h5>
                          <hr />
                        </div>

                        {isLoading ? (
                          <div className="d-flex justify-content-center">
                            <div className="sk-fold sk-primary">
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                              <div className="sk-fold-cube"></div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="row">
                              <div className="col-12 col-md-6">
                                <div className=" g-3">
                                  {/* Start Date */}
                                  <div className="col-12 col-md-6">
                                    <label className="text-sm mb-1 d-block">Start Date</label>
                                    <DatePicker
                                      value={selectedDateRange[0]}
                                      format="dd/MM/yyyy"
                                      editable={false}               // 👈 year dropdown
                                      className="w-100"
                                      placeholder="Start Date"
                                      onChange={(value) =>
                                        setSelectedDateRange([value, selectedDateRange[1]])
                                      }
                                    />
                                  </div>

                                  {/* End Date */}
                                  <div className="col-12 col-md-6">
                                    <label className="text-sm mb-1 d-block">End Date</label>
                                    <DatePicker
                                      value={selectedDateRange[1]}
                                      format="dd/MM/yyyy"
                                      editable={false}               // 👈 year dropdown
                                      className="w-100"
                                      placeholder="End Date"
                                      disabled={!selectedDateRange[0]}
                                      disabledDate={(date) =>
                                        selectedDateRange[0] && date < selectedDateRange[0]
                                      }
                                      onChange={(value) =>
                                        setSelectedDateRange([selectedDateRange[0], value])
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label">Products</label>
                                <Select
                                  options={productData}
                                  value={selectedProduct}
                                  onChange={(option) => setSelectedProduct(option)}
                                  placeholder="Select Product"
                                  isSearchable
                                />
                              </div>
                              <div className="pt-4">
                                <button
                                  type="button"
                                  className="btn btn-outline-success waves-effect"
                                  onClick={() => {
                                    setCurrentPage(1);
                                    getLogsDetails(1);
                                  }}
                                  disabled={!selectedProduct}
                                >
                                  <span className="ti-xs ti ti-search me-1"></span>Search
                                </button>{" "}
                                &nbsp;&nbsp;&nbsp;
                                <button
                                  type="button"
                                  className="btn btn-outline-primary waves-effect"
                                  onClick={exportExcel}
                                >
                                  <span className="ti-xs ti ti-download me-1"></span>Export Report
                                </button>
                              </div>
                            </div>


                            <div className="row mt-4">
                              <div className="table-responsive custom-table-wrapper">
                                <table className="table table-bordered table-hover mb-0">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>URN</th>
                                      <th>RC Number</th>
                                      <th>Date</th>
                                      <th>Status Code</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {dashboardListData.length > 0 ? (
                                      dashboardListData.map((currentValue, index) => {
                                        const createdAt = dateFormat(
                                          currentValue.created_at,
                                          "dd-mm-yyyy HH:MM:ss"
                                        );
                                        return (
                                          <tr key={currentValue.id}>
                                            <td>{startIndex + index}</td>
                                            <td>{currentValue.urn}</td>
                                            <td>{currentValue.rc_number}</td>
                                            <td>{createdAt}</td>
                                            <td>
                                              <span
                                                className={
                                                  currentValue.status_code === "200"
                                                    ? "text-success"
                                                    : currentValue.status_code === "404"
                                                      ? "text-warning"
                                                      : "text-danger"
                                                }
                                              >
                                                {currentValue.status_code}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="5" className="text-center">
                                          No records found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>


                            {totalPages > 1 && (
                              <nav aria-label="Page navigation">
                                <Pagination
                                  className="pagination"
                                  count={totalPages}
                                  page={currentPage}
                                  onChange={handlePageChange}
                                />
                              </nav>
                            )}

                            <div className="pagination-info">
                              Showing {startIndex} to {endIndex} of {totalEntries} entries
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default Pan;